import { __assign } from "tslib";
import clsx from 'clsx';
import React from 'react';
import Icon from '../../icon/internal';
import styles from './styles.css.js';
import useFocusVisible from '../../internal/hooks/focus-visible';
export var CircularButton = React.forwardRef(function (_a, ref) {
    var className = _a.className, ariaLabel = _a.ariaLabel, ariaExpanded = _a.ariaExpanded, iconName = _a.iconName, disabled = _a.disabled, selected = _a.selected, onClick = _a.onClick;
    var focusVisible = useFocusVisible();
    return (React.createElement("button", __assign({}, focusVisible, { ref: ref, type: "button", disabled: disabled, className: clsx(styles['circular-toggle'], selected && styles['circular-toggle-selected'], className), "aria-label": ariaLabel, "aria-expanded": ariaExpanded, onClick: onClick }),
        React.createElement(Icon, { name: iconName })));
});
//# sourceMappingURL=circular-button.js.map